define('areas/home/model/sidebar',["require", "exports", "areas/home/model/sidebaritem", "common/string", "services/navigator"], function (require, exports, SidebarItem, Strings, Navigator) {
    "use strict";
    var Sidebar = (function () {
        function Sidebar(navigateCommand) {
            this.isExpanded = false;
            this.items = [];
            this.current = "";
            this.groups = [];
            this.isInEditMode = false;
            this._navigateCommand = navigateCommand;
            ko.track(this, ["items", "isExpanded", "current", "isInEditMode"]);
        }
        Sidebar.prototype.buildUp = function (node, currentNode) {
            var _this = this;
            this.groups = node.groups;
            var items = [];
            this.items = [];
            Enumerable.From(node.children)
                .OrderBy(function (x) { return x.groupId; })
                .GroupBy(function (x) { return x.groupId; })
                .ForEach(function (gr) {
                var parentGroup = Enumerable.From(_this.groups).FirstOrDefault(null, function (x) { return x.key === gr.Key(); });
                items.push(new SidebarItem(parentGroup, gr.ToArray()));
            });
            this.items = Enumerable.From(items).OrderBy(function (x) { return x.index; }).ToArray();
            if (this.shouldSelectFirstItem())
                this.selectFirstItem();
            if (currentNode != null) {
                this.setCurrentNode(currentNode);
            }
        };
        Sidebar.prototype.execute = function (item) {
            var _this = this;
            if (item.alwaysShowTiles) {
                this.current = item.title;
                var currentRoute = Navigator.activeRoute();
                if (currentRoute.route !== "" && currentRoute.route !== "home") {
                    Navigator.navigateHome();
                }
            }
            else {
                if (item.title === this.current && item.childs.length === 1)
                    return;
                if (item.childs.length === 1) {
                    this._navigateCommand.execute(item.childs[0]);
                    setTimeout(function () {
                        _this.current = item.title;
                    }, 100);
                }
                else {
                    this.current = item.title;
                    var currentRoute = Navigator.activeRoute();
                    if (currentRoute.route !== "" && currentRoute.route !== "home") {
                        Navigator.navigateHome();
                    }
                }
            }
        };
        Sidebar.prototype.setCurrentNode = function (node) {
            if (node.groupId != null) {
                var group = Enumerable.From(this.groups)
                    .FirstOrDefault(null, function (g) { return g.key === node.groupId; });
                if (group != null) {
                    this.current = group.title;
                }
            }
        };
        Sidebar.prototype.selectFirstItem = function () {
            var groups = [];
            Enumerable.From(this.items)
                .ForEach(function (x) {
                groups.push(x.group);
            });
            var group = Enumerable.From(groups)
                .Where(function (x) { return x.autoSelectIndex > -1; })
                .OrderBy(function (x) { return x.autoSelectIndex; })
                .FirstOrDefault(null);
            if (group == null) {
                group = Enumerable.From(groups)
                    .OrderBy(function (x) { return x.index; })
                    .FirstOrDefault(null);
            }
            if (group != null) {
                var item = Enumerable.From(this.items)
                    .FirstOrDefault(null, function (x) { return x.title === group.title; });
                this.execute(item);
            }
        };
        Sidebar.prototype.shouldSelectFirstItem = function () {
            if (Strings.contains(window.location.search, "uri=")) {
                return false;
            }
            if (!Strings.isNullOrEmpty(window.location.hash) && window.location.hash !== "#") {
                return false;
            }
            return true;
        };
        return Sidebar;
    }());
    return Sidebar;
});

